/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import { Random } from "random-js";
import axios from '@/axios.js'
import con from '@/firebase/firebaseInit.ts'
import firebase from 'firebase';
import ls from "@/common/localStorage"

//const cn = 'OA_UAT_C1591205467009E1591206650065'
var cn = ls.getSessionEventCollectionName();
const groupRef = con.eventDB.collection(cn).doc('GroupList').collection('Groups')
var sessionRef = con.eventDB.collection(cn).doc("SessionList").collection("Sessions");
const storageRef = con.storageRef
var Session_Client_Id = ls.getSessionValueByKey('Session_Client_Id');
var Session_Event_Id = ls.getSessionValueByKey('Session_Event_Id');
var Session_UserId = ls.getSessionValueByKey('UserId');
var attendeeRef = con.eventDB.collection(cn).doc("AttendeeList").collection("Attendees");
var userEventsRef = con.instanceDB.doc("ClientList").collection("Clients").doc(Session_Client_Id).collection('UserEvents');
var FirebaseAuthApi = con.FirebaseAuthApi;
var CreateGroupAPI = con.CreateGroupAPI;
var SessionAttendeeMappingAPI = con.SessionAttendeeMappingAPI;
var DeleteCollectionApi = con.DeleteCollectionApi

export default {
    fetchGroups({ commit }) {
        return new Promise((resolve, reject) => {
            const markers = []        
            let count = 0
            let totallength = 0    
            groupRef.get().then(querySnapshot => {
                totallength = querySnapshot.docs.length
                querySnapshot.docs.forEach(doc => {
                    var docObj = doc.data();
                    docObj.IsPublished = doc.data().IsPublished ? true : false
                    //groupRef.doc(doc.id).collection('MappedAttendees').get().then(attendees =>{
                        //docObj.NumberofAttendees = attendees.docs.length
                        //groupRef.doc(doc.id).collection('MappedSessions').get().then(sessions =>{
                            //docObj.NumberofSessions =  sessions.docs.length
                            markers.push(docObj) 
                            /*count++ 
                            if(count == totallength)
                            {
                                commit('SET_GROUPS', markers)
                                resolve(markers)
                            } */                          
                        //})
                    //})
                })
                commit('SET_GROUPS', markers)
                resolve(markers)
                
            }).catch(function(error) {
                //console.log('Error getting attendee:', error)
                reject(error)
            })
        })
    },
    fetchGroup(context, id) {
        //console.log(id)
        return new Promise((resolve, reject) => {
            if (id === null) {
                context.dispatch('generateNumber', 8).then(function(randomNumber){
                    resolve({
                        status: 200,
                        data: {
                            Title: '',
                            IsPublished: true,
                            designJson: null,
                            randomNumber: randomNumber
                        }
                    })
                })
            } else {
                let docObj = new Object
                groupRef.doc(`${id}`).get().then(function(doc) {
                    docObj = doc.data()
                    resolve({
                        status: 200,
                        data: docObj
                    })             
                })
            }
        })
    },
    fetchAttendeesInGroup(context, id){
        return new Promise((resolve, reject) => {            
            let markers = []
            //groupRef.doc(`${id}`).collection('MappedAttendees').get().then(function(querysnap) {
            groupRef.doc(`${id}`).get().then(function(doc) {
                /*querysnap.docs.forEach(doc => {
                    markers.push(doc.data())
                })*/
                markers = doc.data().Attendees ? doc.data().Attendees : []
                resolve(markers)             
            })
        })
    },
    fetchSessionsInGroup(context, id){
        return new Promise((resolve, reject) => {            
            let markers = []
            //groupRef.doc(`${id}`).collection('MappedSessions').get().then(function(querysnap) {
              groupRef.doc(`${id}`).get().then(function(doc) {  
                /*querysnap.docs.forEach(doc => {
                    markers.push({
                        SessionId: doc.data().SessionId,
                        StartDate: doc.data().StartDate,
                        EndDate: doc.data().EndDate,
                        Track: doc.data().Track,
                        Name: doc.data().Name
                    })
                })*/
                markers = doc.data().Sessions ? doc.data().Sessions : []
                resolve(markers)             
            })
        })
    },
    fetchAttendeesInGroupbyMultipleId(context, GroupIds){
        return new Promise((resolve, reject) => {            
            let markers = []
            let totallength = GroupIds.length
            let count = 0
            if(GroupIds.length){
                GroupIds.forEach( id => {
                    groupRef.doc(`${id}`).collection('MappedAttendees').get().then(function(querysnap) {
                        querysnap.docs.forEach(doc => {
                            markers.push({
                                AttendeeId: doc.data().AttendeeId,
                                Name: doc.data().Name ? doc.data().Name : null,
                                FirstName: doc.data().FirstName,
                                LastName: doc.data().LastName ? doc.data().LastName : null,
                                Email: doc.data().Email ? doc.data().Email : null
                            })
                        })
                        count++
                        if(count == totallength)
                            resolve(markers)  
                    })                           
                })
            }
            else
                resolve(markers)
            })
    },
    fetchGroupsBymultipleAttendees(context, Attendees){
        return new Promise((resolve, reject) => {  
            let markers = []
            let totalAttendees = Attendees.length
            let count = 0
            if(totalAttendees)
            {
                Attendees.forEach(row =>{
                    attendeeRef.doc(`${row.AttendeeId}`).collection('MappedGroup').get().then(function(querysnap) {
                        querysnap.docs.forEach(doc => {
                            markers.push(doc.data())                        
                        })
                        count++
                        if(count == totallength)
                            resolve(markers)
                    })
                })
            }
            else
            {
                resolve(markers)
            }
        })
    },
    getSessionsWithAttendees(context){
        return new Promise((resolve, reject) => {            
            let markers = []
            sessionRef.orderBy("Name").get().then(function(querysnap) {
                let totallength = querysnap.docs.length
                let scount =  querysnap.docs.length
                let count = 0
                console.log(scount)
                querysnap.docs.forEach(sessionDoc => {
                    let sessionObj = sessionDoc.data()
                    let GroupIds = []
                    let attendees = []
                    markers.push(sessionObj)                        

                    /*sessionRef.doc(`${sessionDoc.id}`).collection('MappedAttendees').orderBy("FirstName").get().then(function(snap) {
                        let acount = snap.docs.length
                        console.log(acount)
                        snap.docs.forEach( attendeeDoc => {
                            markers.push({
                                SessionName: `\"${sessionDoc.data().Name}\"`,
                                AttendeeName: attendeeDoc.data().FirstName + " " + attendeeDoc.data().LastName,
                                AttendeeEmail: attendeeDoc.data().Email
                            })
                        })   
                        count++  
                                           
                    })*/
                })
                resolve(markers)
            })
        })
    },
    fetchGroupsInSession(context, id){
        return new Promise((resolve, reject) => {            
            let markers = []
            sessionRef.doc(`${id}`).collection('MappedGroups').get().then(function(querysnap) {
                querysnap.docs.forEach(doc => {
                    markers.push(doc.data())
                })
                resolve(markers)             
            })
        })
    },
    fetchAttendeesInSession(context, id){
        return new Promise((resolve, reject) => {            
            let markers = []
            sessionRef.doc(`${id}`).get().then(function(doc) {
                /*querysnap.docs.forEach(doc => {
                    markers.push(doc.data())
                })*/
                markers = doc.data().IncludedAttendees ? doc.data().IncludedAttendees : []
                resolve(markers)             
            })
        })
    },
    fetchSessionsInAttendee(context, id){
        return new Promise((resolve, reject) => {            
            let markers = []
            attendeeRef.doc(`${id}`).collection('MappedSessions').get().then(function(querysnap) {
                querysnap.docs.forEach(doc => {
                    markers.push(doc.data())
                })
                resolve(markers)             
            })
        })
    },
    updateGroup(context, field) {
        return new Promise((resolve, reject) => {
            let docObj = {
                    Title: field.data.Title,
                    IsPublished: field.data.IsPublished,
                    designJson: field.data.designJson,
                    html: field.data.html,
                    LastModifiedDate: new Date()
                }

            groupRef.doc(`${field.id}`).update(docObj).then(function(doc) {
                resolve({ status: 200, message: 'Data Updated.' })        
            }).catch(function(error) {
                //console.log('Error getting update attendee:', error)
                reject(error)
            })
        })
    },
    addGroup(context, field) {   
        return new Promise((resolve, reject) => {
            context.dispatch('getFirebaseAccessToken').then(accessToken => {
                //console.log(accessToken)
                let headers = {
                    'Authorization': `Bearer ${accessToken}`,
                    "content-type": "application/json"                                 
                }

                let requestData = {
                    "source": "web",
                    //"token": `${accessToken}`,
                    "key": {
                        "instanceId": "OA_UAT",
                        "clientId": Session_Client_Id,
                        "eventId": Session_Event_Id
                    },
                    "data": {
                        "groups":[
                            {
                                "GroupName": `${field.GroupName}`
                            }                           
                        ] 
                    }
                }

                axios.post(CreateGroupAPI, requestData, { headers: headers }).then((response) => {
                    //console.log(response)
                    resolve({status:200, message: "group created", Group: response.data.result[0]})
                }).catch((error) => { 
                    console.log(error) 
                    resolve({status:500, message: "group not created"})
                })
            })
        })
    },


    async getAutoId(context) {
        //let AutoId = 0;
        let promise = new Promise((resolve, reject) => {
            con.instanceDB.doc("AutoID").get().then(function(doc) {
                if (!doc.exists) {
                    con.instanceDB.doc("AutoID").set({ UserId: 0 })
                    resolve(1)
                } else {
                    con.instanceDB.doc("AutoID").update({
                        UserId: firebase.firestore.FieldValue.increment(1)
                    }).then(function() {
                        con.instanceDB.doc("AutoID").get().then(function(doc) {
                            resolve(doc.data().UserId)
                        })
                    })
                }
            })
        })

        let AutoId = await promise;
        AutoId = AutoId * 1000;
        return await AutoId.toString();
    },
    changeStatus(context, field) {
        return new Promise((resolve, reject) => {
                let totallength = field.data.length;
                let count = 0;
                for (var i = 0; i < field.data.length; i++) {
                    let data = field.data[i]
                    groupRef.doc(`${data.GroupId}`)
                        .update({ IsPublished: field.Status })
                        .then(function() {
                            count = count + 1;
                            if (totallength == count)
                                resolve({ status: 200, message: 'Status Changed of ' + count + ' Record' })
                        })
                }
            }) // end of promise
    },
    generateNumber(context, numberLength) {
        const random = new Random(); // uses the nativeMath engine
        const value = random.hex(numberLength);
        //const value = random.integer(100000, 999999);
        return value.toString();
    },
    mapSessionAttendee(context, field){
        return new Promise((resolve, reject) => {
            //context.dispatch('fetchGroupsBymultipleAttendees', field.attendees).then(mapgroups => { 
                //context.dispatch('fetchGroupsBymultipleAttendees', field.unmap_attendees).then(unmapgroups => { 
                    context.dispatch('getFirebaseAccessToken').then(accessToken => {                    
                        let headers = {
                            'Authorization': `Bearer ${accessToken}`,
                            "content-type": 'application/json'
                        }                        

                        let requestData = {
                            "source": "web",
                            //"token": `${accessToken}`,
                            "key": {
                                "instanceId": "OA_UAT",
                                "clientId": Session_Client_Id,
                                "eventId": Session_Event_Id
                            },
                            "data": {
                                "sessions": field.sessions,                            
                                "map": {
                                    "attendees": field.attendees,
                                    "groups" : field.mapgroups
                                },
                                "unmap": {
                                    "attendees": field.unmap_attendees,
                                    "groups" : field.unmapgroups
                                }
                            }
                        }

                        //console.log(requestData)
                        axios.put( SessionAttendeeMappingAPI, requestData, { headers:headers }).then((response) => {
                            //console.log(response)
                            resolve({status:200, message: "Attendees Mapped to session"})
                        }).catch((error) => { 
                            //console.log(error) 
                            resolve({status:500, message: "Attendees not Mapped to session"})
                        })                    
                        
                    })   
                //}) 
            //})                  
        })
    },    
    updateMapSessionStatus(context, field) {
        return new Promise((resolve, reject) => {
            context.dispatch('getFirebaseAccessToken').then(accessToken => {                    
                //console.log(accessToken)
                //let token = JSON.stringify(JSON.parse(accessToken))
                let headers = {
                    'Authorization': `Bearer ${accessToken}`,
                    "content-type": 'application/json'
                }
            

                let requestData = {
                    "source": "web",
                    //"token": `${accessToken}`,
                    "key": {
                        "instanceId": "OA_UAT",
                        "clientId": Session_Client_Id,
                        "eventId": Session_Event_Id
                    },
                    "data": {
                        "sessions": field.sessions,
                        "value": {
                            "IsPublished": field.IsPublished
                        }                      
                    }
                }
                //console.log(requestData)
                axios.put( SessionAttendeeMappingAPI, requestData, { headers:headers }).then((response) => {
                    //console.log(response)
                    resolve({status:200, message: "Status Changed"})
                }).catch((error) => { 
                    //console.log(error) 
                    resolve({status:500, message: "Status Not Changed"})
                })                    
                
            })             
        })
    },
    mapAttendeestoGroup(context, field){
        return new Promise((resolve, reject) => {
            //console.log(field.attendee_list)
            /*let headers = {
                "Content-Type": "application/json",
                "apikey": "ws2000rb28082019"
            }
            let dataRaw = {
                "colname":"/"+ cn + "/GroupList/Groups/"+ `${field.Group.GroupId}` +"/MappedAttendees"                       
            } */
            //axios.post(DeleteCollectionApi, dataRaw, { headers: headers }).then((response) => {
                context.dispatch('getFirebaseAccessToken').then(accessToken => {
                    //console.log(accessToken)
                    let headers = {
                        'Authorization': `Bearer ${accessToken}`,
                        "content-type": "application/json"                        
                    }

                    let requestData = {
                        "source": "web",
                        //"token": `${accessToken}`,
                        "key": {
                            "instanceId": "OA_UAT",
                            "clientId": Session_Client_Id,
                            "eventId": Session_Event_Id
                        },
                        "data": {
                            "groups":[{
                                "GroupId": `${field.Group.GroupId}`,
                                "GroupName": `${field.Group.GroupName}`
                            }],
                            "map": {
                                "attendees": field.attendee_list
                            }                        
                        }
                    }

                    axios.put(CreateGroupAPI, requestData, { headers: headers }).then((response) => {
                        //console.log(response)
                        resolve({status:200, message: "Attendees Mapped to group"})
                    }).catch((error) => { 
                        console.log(error) 
                        resolve({status:500, message: "Attendees not Mapped to group"})
                    })
                })          
            //})
            
        })
    },
    unmapAttendeestoGroup(context, field){
        return new Promise((resolve, reject) => {            
            context.dispatch('getFirebaseAccessToken').then(accessToken => {
                //console.log(accessToken)
                let headers = {
                    'Authorization': `Bearer ${accessToken}`,
                    "content-type": "application/json"                        
                }

                let requestData = {
                    "source": "web",
                    //"token": `${accessToken}`,
                    "key": {
                        "instanceId": "OA_UAT",
                        "clientId": Session_Client_Id,
                        "eventId": Session_Event_Id
                    },
                    "data": {
                        "groups":[{
                            "GroupId": `${field.Group.GroupId}`,
                            "GroupName": `${field.Group.GroupName}`
                        }],
                        "unmap": {
                            "attendees": field.attendee_list
                        }                        
                    }
                }

                axios.put(CreateGroupAPI, requestData, { headers: headers }).then((response) => {
                    //console.log(response)
                    resolve({status:200, message: "Attendees Mapped to group"})
                }).catch((error) => { 
                    console.log(error) 
                    resolve({status:500, message: "Attendees not Mapped to group"})
                })
            })          
            
        })
    },
    updateStatus(context, field){
        return new Promise((resolve, reject) => {            
            context.dispatch('getFirebaseAccessToken').then(accessToken => {
                //console.log(accessToken)
                let headers = {
                    'Authorization': `Bearer ${accessToken}`,
                    "content-type": "application/json"                        
                }

                let requestData = {
                    "source": "web",
                    //"token": `${accessToken}`,
                    "key": {
                        "instanceId": "OA_UAT",
                        "clientId": Session_Client_Id,
                        "eventId": Session_Event_Id
                    },
                    "data": {
                        "groups":field.groups,
                        "value": {
                            "IsPublished": field.IsPublished
                        }                       
                    }
                }

                axios.put(CreateGroupAPI, requestData, { headers: headers }).then((response) => {
                    //console.log(response)
                    resolve({status:200, message: "Status Changed"})
                }).catch((error) => { 
                    console.log(error) 
                    resolve({status:500, message: "Status Not Changed"})
                })
            })          
            
        })
    },
    getFirebaseAccessToken(context){
        return new Promise((resolve, reject) => {
            let accessToken = ls.getSessionValueByKey("Session_AccessToken")
            resolve(accessToken);
      })
    },
    removeSessionMapping(context, session) {
        return new Promise((resolve, reject) => {    
            context.dispatch('fetchGroupsInSession', session.SessionId).then(groups => {          
                context.dispatch('fetchAttendeesInSession', session.SessionId).then(attendees => {
                    let data = {
                        sessions: [{SessionId: session.SessionId}],
                        attendees: [],
                        mapgroups: [],
                        unmap_attendees: attendees,
                        unmapgroups: groups
                    }
                    context.dispatch('mapSessionAttendee', data).then(response => {
                        resolve('Session unmapped.')
                    })
                })  
            })               
                
        })
    },
    removeSessionMappingBulk(context, sessions) {
        return new Promise((resolve, reject) => {
            context.dispatch('getFirebaseAccessToken').then(accessToken => {                    
                let headers = {
                    'Authorization': `Bearer ${accessToken}`,
                    "content-type": 'application/json'
                }
            

                let requestData = {
                    "source": "web",
                    //"token": `${accessToken}`,
                    "key": {
                        "instanceId": "OA_UAT",
                        "clientId": Session_Client_Id,
                        "eventId": Session_Event_Id
                    },
                    "data": {
                        "sessions": sessions,                                                
                    }
                }
                axios.delete( SessionAttendeeMappingAPI,{ headers:headers,data: requestData}).then((response) => {
                    resolve({status:200, message: "Mapped Session Deleted"})
                }).catch((error) => { 
                    console.log(error) 
                    resolve({status:500, message: "Mapped Session not Deleted"})
                })                    
                
            }) 
        })
    },
    removeGroupMapping(context, groups) {
        return new Promise((resolve, reject) => {
            context.dispatch('getFirebaseAccessToken').then(accessToken => {                    
                let headers = {
                    'Authorization': `Bearer ${accessToken}`,
                    "content-type": 'application/json'
                }
            

                let requestData = {
                    "source": "web",
                    //"token": `${accessToken}`,
                    "key": {
                        "instanceId": "OA_UAT",
                        "clientId": Session_Client_Id,
                        "eventId": Session_Event_Id
                    },
                    "data": {
                        "groups": groups,                                                
                    }
                }
                axios.delete( CreateGroupAPI,{ headers:headers,data: requestData}).then((response) => {
                    context.commit('REMOVE_GROUPS', groups[0].GroupId)
                    resolve({status:200, message: "Mapped Group Deleted"})
                }).catch((error) => { 
                    console.log(error) 
                    resolve({status:500, message: "Mapped Group not Deleted"})
                })                    
                
            }) 
        })
    }
}